import React from 'react';
import './Departments.css';
import Departments from '../../components/Departments/Departments';

const OurDepartments = () => {
  return (
    <div className="our-departments">
      <div className="our-departments-wrapper">
        <div className='our-departments-intro'>
          <h2 className="our-departments-title">Departments</h2>
        <p className="our-departments-intro">Igbo-Eze North Local Government Council delivers services to the people through eight functional departments. Each department is tasked with implementing sector-specific programmes, managing resources, and supporting the Council’s development agenda.</p>
        </div>
        <Departments />

        <div className="our-departments-closing">
          <p>
            Each department plays a crucial role in delivering inclusive, accountable, and development-driven governance across Igbo-Eze North.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OurDepartments;
